import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/hooks/useAuth";
import { QueryClient, QueryClientProvider } from "react-query";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.scss";

//redux
import store from "./redux/store";
import { Provider } from "react-redux";
import Alert from "./components/layout/Alert";

// Lazy-loaded page components
const PrivacyPage = lazy(() => import("./components/legal/PrivacyPage"));
const TermsPage = lazy(() => import("./components/legal/TermsPage"));
const DataDeletionPage = lazy(() => import("./components/legal/DataDeletionPage"));
const DeletionStatusPage = lazy(() => import("./components/legal/DeletionStatusPage"));
const MarketingPage = lazy(() => import("./components/legal/MarketingPage"));
const UpdatesPage = lazy(() => import("./components/legal/UpdatesPage"));
const GamesPage = lazy(() => import("./components/games/GamesPage"));
const GameManualPage = lazy(() => import("./components/games/GameManualPage"));
const FeedbackPage = lazy(() => import("./components/feedback/FeedbackPage"));
const OAuthCallback = lazy(() => import("./components/authPage/OAuthCallback"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            cacheTime: 5 * 60_000,
        },
    },
});
export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <BrowserRouter>
                    <AuthProvider>
                        <ErrorBoundary>
                        <Alert />
                        <Suspense fallback={<div className="loading-screen">Loading...</div>}>
                        <Routes>
                            <Route path="/" element={<Navigate to="/about" replace />} />
                            <Route path="/about" element={<MarketingPage />} />
                            <Route path="/games" element={<GamesPage />} />
                            <Route path="/games/:slug" element={<GameManualPage />} />
                            <Route path="/updates" element={<UpdatesPage />} />
                            <Route path="/feedback" element={<FeedbackPage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/data-deletion" element={<DataDeletionPage />} />
                            <Route path="/deletion-status" element={<DeletionStatusPage />} />
                            <Route path="/oauth-callback" element={<OAuthCallback />} />
<Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        </Suspense>
                        </ErrorBoundary>
                    </AuthProvider>
                </BrowserRouter>
            </Provider>
        </QueryClientProvider>
    );
}
